import React, { useEffect, useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const Loader = () => {
  const theme = useTheme();
  const [dots, setDots] = useState('');

  useEffect(() => {
    let dotIndex = 0;
    const intervalId = setInterval(() => {
      dotIndex = (dotIndex + 1) % 4;
      setDots('.'.repeat(dotIndex));
    }, 500);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Box
      className="blades"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          height: '40px',
          width: '40px',
          animation: 'spin 1s infinite linear',
          '@keyframes spin': {
            to: {
              transform: 'rotate(360deg)',
            },
          },
        }}
      >
        <div style={loaderStyle(theme.palette.primary.main, 72)}></div>
        <div style={loaderStyle(theme.palette.primary.main, 144)}></div>
        <div style={loaderStyle(theme.palette.primary.main, 216)}></div>
        <div style={loaderStyle(theme.palette.primary.main, 288)}></div>
        <div style={loaderStyle(theme.palette.primary.main, 360)}></div>
      </Box>
      <Typography sx={{ marginTop: 2 }}>
        Authenticating
        <Box component="span" sx={{ width: '1em', textAlign: 'left', display: 'inline-block' }}>
          {dots}
        </Box>
      </Typography>
    </Box>
  );
};

const loaderStyle = (color, rotation) => ({
  border: '4px solid transparent',
  borderLeftColor: color,
  height: '20px',
  width: '20px',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transformOrigin: 'top left',
  transform: `rotate(${rotation}deg) translateY(5px)`,
});

export default Loader;